<template>
  <section class="section--pd section--pb-lg">
    <div class="inner">
      <div class="cotree__banner">
        <a href="https://cotree.jp/users/register?code=MELON_cotree">
          <img
            src="assets/img/banner_cotree.png"
            alt="ご利用満足度93% いるでも頼れるパートナーが見つかる オンラインカウンセリング cotree"
          ></a>
      </div>
      <p class="cotree__ttl">
        cotree × MELON <br
          class="_dsp-none--pc"
        >初回カウンセリングが2,000円OFF
      </p>
      <p class="cotree__bodyText">
        <a href="https://cotree.jp/">｢cotree（コトリー）｣</a>は、厳正な審査に通過した臨床心理士などの専門家にビデオ・通話・チャット形式で相談できるオンラインカウンセリングサービスです。専門家との対話を通じて、自分とじっくり向き合うことができます。<br><br>
        「MELON」ご利用者のみなさまは、専用コード経由でお申し込みいただくことで、<span>初回のオンラインカウンセリング利用料が2,000円OFF（税別）</span>になる割引特典をご利用いただけます。上記のバナーからお申し込みください。
      </p>
      <div class="cotree__commentArea">
        <div class="cotree__commentBox">
          <div class="cotree__commentBox__top">
            <figure class="cotree__commentBox__pic">
              <img src="assets/img/ph_kugaya.jpg" alt="医師・医学博士 久賀谷亮先生">
            </figure>
            <p class="cotree__commentBox__name">
              <span>医師・医学博士</span><br>久賀谷亮先生
            </p>
          </div>
          <p class="cotree__commentBox__comment">
            「カウンセリングは、対話を通して頭を整頓する作業です。マインドフルネスは、こころの基調線を落ち着かせるセルフケアです。よりロジカルなアプローチと、それでは割り切れない隙間を埋めるアプローチの組み合わせは、相補的に優れた効果をもたらすことがわかっています。」
          </p>
        </div>
        <div class="cotree__commentBox">
          <div class="cotree__commentBox__top">
            <figure class="cotree__commentBox__pic">
              <img src="assets/img/ph_maeda.jpg" alt="医師・産業医 前田佳宏先生">
            </figure>
            <p class="cotree__commentBox__name">
              <span>医師・産業医</span><br>前田佳宏先生
            </p>
          </div>
          <p class="cotree__commentBox__comment">
            「心理療法は組み合わせることで互いを補う効果があります。マインドフルネスは自分で手軽に気持ちをリセットできて、カウンセリングは一人ではたどり着きにくい気づきや感情をいろんな視点で見つめ直します。相性もあるので、それぞれ試すのもいいですね。」
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Cotree'
}
</script>
